import {useContext} from 'react';
import {StoreContext} from '@roc/feature-app-core';
import {ProposalsStore,ProposalsDetailsStore,ProposalTopicsStore} from '../stores'

export const useProposalsStore=() => useContext<{
  proposalsStore: ProposalsStore,
  proposalsDetailsStore: ProposalsDetailsStore,
  proposalTopicStore: ProposalTopicsStore
}>(StoreContext);
